export const LOGIN_START_LOADING = "LOGIN_START_LOADING";
export const LOGIN_END_LOADING = "LOGIN_END_LOADING";
export const LOGIN_LOADED = "LOGIN_LOADED";
export const LOGIN_TOKEN_LOADED = "LOGIN_TOKEN_LOADED";
export const LOGIN_DATA_LOADED = "LOGIN_DATA_LOADED";
export const CHANGE_PASSWORD_LOADED = "CHANGE_PASSWORD_LOADED";